import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { icons } from "../../assets/icons";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import CustomTable from "../../components/CustomTable";
import {
  usersListColumns,
} from "../../components/Columns/Users";
import SwitchButton from "../../components/FormFields/SwitchButton";
import WrapperWithTabs from "../../components/WrapperWithTabs";
import SelectInput from "../../components/FormFields/SelectInput";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { groupsListColumns } from "../../components/Columns/Groups";
import { rolesListColumns } from "../../components/Columns/Roles";

const CreateUsers = () => {
const { data = [], apiCall } = useApi();
const {apiCall: specificUserCall, apiCall: updateUserDetails } = useApi();
const { data: roles = [], apiCall: getRoles, apiCall: getDesignation, apiCall: createUserCall } = useApi();
const [selectedDesignationData, setSelecDesignationData] = useState([]);
const [specificData ,setSpecificData] = useState([]);
const paramsData = useLocation();
const isUpdateUserActive = paramsData?.state?.id ? true : false;
const [formData, setFormData] = useState({
  active: paramsData?.state?.active || true,
  email: paramsData?.state?.email || "",
  groupIds: specificData.groupIds || [],
  // id: 0,
  mobile: paramsData?.state?.mobile || "",
  name: paramsData?.state?.name || "",
  ownerUsername: paramsData?.state?.ownerUsername || "",
  password: paramsData?.state?.password || "",
  roleIds: specificData.roleIds || [],
  roleName: paramsData?.state?.roleName || "ADMIN",
  userLabel: paramsData?.state?.userLabel || "",
  username: paramsData?.state?.username || "",
});

const setFormDataFun = (e) => {
  const { name = "", value = "" } = e.target;
  setFormData(prev => ({...prev, [name]: value}))
}

// console.log("user", user)
useEffect(() => {
  paramsData?.state?.id && specificUserCall({
    url: `${apiUrls.sso.getSpecificUser}/${paramsData?.state?.id}`,
    method: "get",
    onSuccess: (res) => {
      setSpecificData(res)
      console.log("response from specific user", res);
    },
  });
  groupGetCall()
  getRolesApi()
}, [selectedDesignationData]);


const getRolesApi = async () => {
  await getRoles({
    url: apiUrls.sso.getRoles,
    method: "get",
  });
};

const listOfNextStateOfSelectedDesignation = (key) => {
  switch (key) {
    case "Store":
      return "L1"
    case "L1":
      return "L2"
    case "L2":
      return "L1"
    default:
      return ""
  }
}

const getDesignationApi = async (id) => {
  await getDesignation({
    url: apiUrls.sso.getDesignations + id,
    method: "get",
    onSuccess: (da) => {
      const convertedArray = Object.entries(da).map(([key, value]) => ({
        id: parseInt(key),
        key: value,
        value
      }));
      convertedArray.unshift({key: "Select List", value: ""})
      convertedArray.length > 0 && setSelecDesignationData(convertedArray)
    },
  });
};

// const getUsersCall = async () => {
//   await apiCall({
//     url: apiUrls.sso.getUsers,
//     method: "get",
//   });
// }

const onClickUpdate = () => {
  // console.log("on Click update", {...formData, id :paramsData.state.id});
  updateUserDetails({
    url: apiUrls.sso.updateUser,
    method: "put",
    dataToSend: {...formData, id :paramsData.state.id, groupIds : formData.groupIds, roleIds: formData.roleIds} || {},
    onSuccess: (da) => {
      toast.success("User Updated successfully");
      navigate(-1);
    },
  });
};


const groupGetCall = () => {
  apiCall({
    url: apiUrls.sso.getGroups,
    method: "get",
  });
};

  const navigate = useNavigate();
  const onClickBack = () => {
    navigate(-1);
  };

  const designationOptions = [
    {
      key: "Select Designation",
      value: "",
    },
    {
      key: "Finance",
      value: "Finance",
    },
    {
      key: "L2",
      value: "L2",
    },
    {
      key: "L1",
      value: "L1",
    },
    {
      key: "Store",
      value: "Store",
    },
  ];

  const AssignGroupCheckboxSelect = (groups = []) => {
    // console.log("selected checkboxed", e);
    if(groups.length > 0){
      let groupIds = groups?.map(i => i.original.id)
      setFormData(prev => ({...prev, groupIds: groupIds}))
    }
  }

  const AssignRoleCheckboxSelect = (roles = []) => {
    // console.log("selected checkboxed", e);
    if(roles.length > 0){
      let roleIds = roles?.map(i => i.original.id)
      setFormData(prev => ({...prev, roleIds: roleIds}))
    }
  }

  const selectPositionFun = (rows, user) => { // for select initial position using index
    // rows will table data
    // user will be select data
    // console.log("asdfasdfasdf", rows, user);
    let arr = user;
    let data = rows?.map((i, ind) => {
      if(arr?.includes(i.id)){
        return ind;
      }
    }) || [];
    return data || [];
  }

  const tabBarOptions =
  [
    {
      id: 1,
      title: "Assign Group",
      Component: ({ data }) => {
        return (
          <div className="mb-4">
            <div className="flex justify-end mb-4 mt-4">
              {/* <InputWithIcon
                placeholder="Search Roles"
                containerClassName="search-input-wrapper"
                wrapperClassName="!h-[4rem]"
                inputClassName="font-size-small"
                rightIcon={icons.searchIcon}
                //   onChange={(e) => setSearchText(e)}
                //   value={searchText}
              /> */}
              {/* <CustomButton
                title="Create Group"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                icon={icons.plusBlackIcon}
                onClick={() => {
                  navigate("/groups/create");
                }}
              /> */}
            </div>
            <CustomTable
              isGlobalSearchEnable={true}
              globalSearchPosition={{
                position: "absolute",
                top: "-53px",
                // left: "176px",
              }}
              showCheckboxes={true}
              onCheckboxSelect={AssignGroupCheckboxSelect}
              initialCheckboxesData={selectPositionFun(data , specificData.groupIds )}
              data={data || []}
              columns={React.useMemo(
                () => groupsListColumns(() => {}, navigate, false),
                []
              )}
            />
          </div>
        );
      },
    },
    {
      id: 2,
      title: "Assign Roles",
      Component: ({ roles }) => {
        return (
          <div className="mb-4">
            <div className="flex justify-end mb-4 mt-4">
              {/* <InputWithIcon
                placeholder="Search Roles"
                containerClassName="search-input-wrapper"
                wrapperClassName="!h-[4rem]"
                inputClassName="font-size-small"
                rightIcon={icons.searchIcon}
                //   onChange={(e) => setSearchText(e)}
                //   value={searchText}
              /> */}
              {/* <CustomButton
                title="Create Group"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                icon={icons.plusBlackIcon}
              /> */}
            </div>
            <CustomTable
              isGlobalSearchEnable={true}
              globalSearchPosition={{
                position: "absolute",
                top: "-53px",
                // left: "176px",
              }}
              showCheckboxes={true}
              data={roles || []}
              onCheckboxSelect={AssignRoleCheckboxSelect}
              initialCheckboxesData={selectPositionFun(roles , specificData.roleIds )}
              columns={React.useMemo(
                () => rolesListColumns(() => {}, false),
                []
              )}
            />
          </div>
        );
      },
    },
  ];

  const onClickCreate = async () => {
    await createUserCall({
      url: apiUrls.sso.createUser,
      method: "post",
      dataToSend: formData || {},
      onSuccess: (da) => {
        toast.success("User Created successfully");
        navigate(-1);
      },
    });
  }
  
  console.log("formdata", formData);
  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Users > Create User"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          return (
            <div className="flex items-center gap-x-6">
              <CustomButton
                title="Back"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                onClick={onClickBack}
                icon={icons.backIcon}
              />
              <CustomButton
                title={isUpdateUserActive ? "Update" : "Save"}
                wrapperClassName="!px-5"
                textClassName="pl-2"
                onClick={isUpdateUserActive ? onClickUpdate : onClickCreate}
              />
            </div>
          );
        }}
      />

      <div className="px-6 py-8 bg-[#fff] mt-10 rounded-[1rem]">
        <div className="font-size-medium font-family-medium mb-3">
          Add User Information
        </div>
        {/* <div className="font-size-small mb-5 text-[var(--darkGray2)]">
          I'm admin for keventers
        </div> */}
        <div className="flex flex-wrap gap-x-10">
          <InputWithIcon
            wrapperClassName="flex-1"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)]"
            title="Email ID"
            placeholder="Enter your email"
            name={"email"}
            type="email"
            onChange={setFormDataFun}
            value={formData.email}
          />
          <InputWithIcon
            wrapperClassName="flex-1"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)]"
            title="Username"
            placeholder="Enter your username"
            name={"username"}
            onChange={setFormDataFun}
            value={formData.username}
          />
          <InputWithIcon
            wrapperClassName="flex-1"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)]"
            title="Name"
            placeholder="Enter your name"
            name={"name"}
            onChange={setFormDataFun}
            value={formData.name}
          />
          <InputWithIcon
            wrapperClassName="flex-1"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)]"
            title="Password"
            type={"password"}
            placeholder="Enter your password"
            name={"password"}
            onChange={setFormDataFun}
            value={formData.password}
          />
          <InputWithIcon
            wrapperClassName="flex-1"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)]"
            title="Phone Number"
            type={"number"}
            placeholder="Enter your mobile "
            name={"mobile"}
            onChange={setFormDataFun}
            value={formData.mobile}
          />
        </div>
        {!isUpdateUserActive && <div className="flex flex-wrap gap-x-10 mt-8 mb-8">
          <SelectInput
            options={designationOptions}
            wrapperClassName="w-[35%]"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)] rounded-md"
            title="Designation"
            onChange={e => {
              setFormData(prev => ({...prev, userLabel: e}))
              if((e == "L1") || (e == "Store") || (e == "L2")){
                getDesignationApi(listOfNextStateOfSelectedDesignation(e))
              } else {
                setSelecDesignationData([])
              }
            }}
          />
          {(selectedDesignationData.length > 0) && <SelectInput
            options={selectedDesignationData}
            wrapperClassName="w-[35%]"
            containerClassName="!bg-transparent border-[1px] border-[var(--borderGray1)]"
            title={listOfNextStateOfSelectedDesignation(formData?.userLabel)+" List" || ""}
            onChange={e => {
              setFormData(prev => ({...prev, ownerUsername: e}))
              // if((e == "L1") || (e == "Store")){
              //   getDesignationApi(e)
              // }
            }}
          />}
        </div>}

        <div className={isUpdateUserActive ? 'mt-8' : ''}>
          <SwitchButton title="Active" value={formData.active} onChange={(e) => {
            setFormData(prev => ({...prev, active: e.target.checked}))
          }}/>
        </div>
      </div>
      <WrapperWithTabs tabBarOptions={tabBarOptions} commonProps={{data, roles}} wrapperClassName="mt-12" />
      <div className="flex items-center justify-between mt-10">
        <CustomButton
          title="Back"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
          textClassName="text-[var(--blackColor)] pl-2"
          onClick={onClickBack}
          icon={icons.backIcon}
        />
        <CustomButton
          title={isUpdateUserActive ? "Update" : "Save"}
          wrapperClassName="!px-5"
          textClassName="pl-2"
          onClick={isUpdateUserActive ? onClickUpdate : onClickCreate}
        />
      </div>
    </div>
  );
};

export default CreateUsers;
